// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  font-family: Lato, sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
  margin: 0;
  box-sizing: border-box;
}

#app_container {
  padding-top: 5rem;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}

@media only screen and (max-width: 768px) {
  #app_container {
    padding-top: 4rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":["* {\n  font-family: Lato, sans-serif;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 16px;\n  margin: 0;\n  box-sizing: border-box;\n}\n\n#app_container {\n  padding-top: 5rem;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n@media only screen and (max-width: 768px) {\n  #app_container {\n    padding-top: 4rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
